<template>
  <div>
    <h1 class="mb-2 font-regular ml-n1">Dashboards</h1>

    <loan-stat
      v-if="
        userObj.role === 'collection-officer' ||
          userObj.role === 'review-officer' ||
          userObj.role === 'loan-supervisor'
      "
    />
    <dashboard-stat v-else-if="can('dashboard')" />
    <div v-else class="card p-4">
      <p class="mb-0">You do not have access to dashboard statistics.</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  // components: { LoanStat },
  name: "Dashboard",
  computed: {
    ...mapGetters(["loggedIn"]),
    userObj() {
      return this.$store.getters.userObj;
    }
  }
};
</script>

<style>
.px--5 {
  padding-right: 5px;
  padding-left: 5px;
}
</style>
